var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScorzaLogoGreenGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 712,
    viewBox: "0 0 688 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.382 512.64C109.164 500.18 0.00028339 462.8 -3.14337e-05 352.44L-4.54388e-05 192.24C-5.64032e-05 66.8229 69.4181 5.39975e-05 213.731 4.13813e-05L477.038 1.83623e-05C615.878 6.72597e-05 687.078 65.8602 687.078 192.24L687.078 258.026C687.047 257.889 673.355 197.861 534.028 176.545C394.542 155.204 65.8574 145.96 65.8574 145.96C65.8574 145.96 118.289 152.456 151.882 156.64C273.259 171.756 462.598 195.774 462.798 195.8L343.059 338.203C318.703 338.306 299.039 346.234 299.039 356C299.039 361.72 305.785 366.809 316.267 370.065L196.382 512.64ZM210.04 712C71.2001 712 -5.75769e-06 646.14 -1.68062e-05 519.76L-2.25574e-05 453.974C0.033913 454.123 13.7376 514.141 153.05 535.455C292.536 556.796 621.221 566.04 621.221 566.04C621.221 566.04 568.789 559.544 535.196 555.36C413.808 540.242 224.444 516.221 224.28 516.2L344.02 373.798C368.375 373.695 388.039 365.766 388.039 356C388.039 350.28 381.294 345.192 370.812 341.936L490.696 199.36C577.914 211.82 687.078 249.2 687.078 359.56L687.078 519.76C687.078 645.177 617.66 712 473.347 712L210.04 712Z",
    fill: "url(#paint0_linear_246_36)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_36",
    x1: 642.5,
    y1: 660,
    x2: 84.6803,
    y2: 91.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EAA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScorzaLogoGreenGradient);
export default __webpack_public_path__ + "static/media/scorza-logo-green-gradient.e003ca06955da50b2055233a5c635f77.svg";
export { ForwardRef as ReactComponent };